import React, { Component } from 'react';
import { map } from 'lodash';
import CustomScroll from 'react-custom-scroll';
import PageLoader from '../common/PageLoader';
import { appBasePath } from '../../constants/staticData';
import EmptyState from '../EmptyState/EmptyState';
import { imageBasePath } from '../../constants/staticData';

export default class Schedule extends Component {
  constructor(props, context) {

    super(props, context);
    this.toggleNotification = this.toggleNotification.bind(this);
    this.state = {
      notificationVisible: false,
      hclick: false,
      currentReqId: null,
      selectedScheduleVal: undefined,
      activeDay: undefined,
    };
  }
  toggleNotification(isVisible) {
    this.setState({ 'notificationVisible': isVisible });
  }

  selectedValues(scheduleVal, scheduleitem) {
    this.setState({
      isHidden: true, selectedScheduleVal: scheduleVal, activeDay: scheduleitem.scheduleDay
    });
  }

  render() {
    const { commonReducer, router } = this.props;

    const scheduleWrapper = map(commonReducer.jobSchedule, (scheduleitem, key) => {
      return (
        <div key={key}>
          <div className="schedule-list">
            <div className="schedule-heading">
              <h5>{scheduleitem.title}</h5>
            </div>
            {map(scheduleitem.jobs, (job, key) => {
              let startDate = new Date(job.jobStartDatetime);
              startDate = startDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
              let serviceVehicleModel = job.userbookingrequest && job.userbookingrequest.vehicles && job.userbookingrequest && job.userbookingrequest.vehicles.carmodel;
              let serviceName = job.garagejobquotesdetail && job.garagejobquotesdetail.length && job.garagejobquotesdetail[0] && job.garagejobquotesdetail[0].garagejobquotesdetail_services && job.garagejobquotesdetail[0].garagejobquotesdetail_services.name;
              let subServiceCount = job.garagejobquotesdetail && job.garagejobquotesdetail.length == 1 ? '' : " +" + (job.garagejobquotesdetail.length - 1) + " More";
              return (
                <div className="schedule-card" key={key}>
                  <ul className="list-unstyled">
                    <li className={job.userbookingrequest && job.userbookingrequest.services && job.userbookingrequest.services.name && job.userbookingrequest.services.name.toLowerCase()}
                      onClick={() => {
                        router && router.push(`${appBasePath}/job/${job.userbookingrequestId}`);
                      }}>
                      <a>
                        <label>{startDate} - {job.userbookingrequest.requestid}</label>
                        <span>{serviceVehicleModel} : <span className="schedule-service-name">{serviceName}</span></span>
                        {job.garagejobquotesdetail && job.garagejobquotesdetail.length == 1 ? "" : <span className="schedule-service-count">{subServiceCount}</span> }
                      </a>
                    </li>
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      );
    });
    return (
      <div>
        <div className="overview-heading schedule-heading">
          <h5>SCHEDULES</h5>
        </div>
        { commonReducer.jobScheduleLoaded && commonReducer.jobScheduleCount ? <div className="schedule-denotion">
          <ul className="list-unstyled">
            <li>
              <label className="service-color"></label>
              <span>Service</span>
            </li>
            <li>
              <label className="wash-color"></label>
              <span>Wash</span>
            </li>
            <li>
              <label className="repair-color"></label>
              <span>Repair</span>
            </li>
          </ul>
        </div>:''}
        <div className="schedule-scroll">
          <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
            {commonReducer.jobScheduleLoaded ? commonReducer.jobScheduleCount ? scheduleWrapper : <EmptyState customClass={"schedule-empty-holder"} image={`${imageBasePath}/schedule-empty.png`} message={'You don’t seem to have any scheduled Jobs.'} /> : <PageLoader />}
          </CustomScroll>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Schedule.jsx